<script>
import MSelectPulldown from '@/components/MSelectPulldown/index.vue'
import { page } from '@/api/business/orderCargo'
export default {
  components: {
    MSelectPulldown
  },
  props: {
    value: {
      type: [Number, String]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      required: false
    },
    existList: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      localValue: this.value,
      page: {
        enabled: false,
        page: 1,
        size: 10,
        total: 0
      }
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    }
  },
  methods: {
    onItemChecked(checkedItem) {
      this.$emit('input', checkedItem.id)
      this.$emit('change', checkedItem)
    },
    loadData(keyword) {
      return new Promise((resolve, reject) => {
        const params = {
          ...this.queryParams,
          page: 1,
          size: 99
        }
        console.log(keyword)
        page(params).then(res => {
          resolve({
            data: res.data.records
          })
          this.page.total = res.data.total
        }).catch(err => {
          reject(err)
        })
      })
    },
    onSearch(keyword) {
      console.log('onSearch', keyword)
    },
    itemDisabled(item) {
      if (this.existList && this.existList.length) {
        return this.existList.some(m => m.cargoNo === item.cargoNo)
      }
      return false
    },
    onItemClick(item) {
      if (this.itemDisabled(item)) {
        return
      }
      this.$refs.pulldown.onItemChecked(item)
    }
  }
}
</script>

<template>
  <m-select-pulldown
    ref="pulldown"
    v-model="localValue"
    :disabled="disabled"
    :clearable="clearable"
    :fetch-options="loadData"
    :page="page"
    :field="{ value: 'id', label: 'cargoNo' }"
    :group="{ enabled: false }"
    :placeholder="placeholder"
    @checked="onItemChecked"
    @search="onSearch"
  >
    <template #content="{ list }">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="item padding-sm cursor"
        :class="{
          'active': item.id === localValue
        }"
        @click="onItemClick(item)"
      >
        <div class="flex justify-between">
          <div>
            <span class="text-bold" style="color: var(--color-text-1);">{{ item.cargoNo }}</span>
            <span style="display: inline-block;margin-left: 10px;" v-if="itemDisabled(item)">(已被该提单选择)</span>
          </div>
          <div>
            <span class="label">起：</span>
            <span>{{ item.loadingPoint || '-' }}</span>
          </div>
        </div>
        <div class="flex justify-between margin-top-sm">
          <div>
            <span>{{ item.cargoTypeName }}·{{ item.cargoSpecName }}·{{ item.cargoQty }}</span>
          </div>
          <div>
            <span class="label">终：</span>
            <span>{{ item.unloadingPoint || '-' }}</span>
          </div>
        </div>
      </div>
    </template>
  </m-select-pulldown>
</template>

<style scoped lang="scss">
.item {
  background: var(--color-fill-2);
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  &.active::after {
    content: '';
    position: absolute;
    top: -1.7em;
    left: -1.7em;
    width: 3.5em;
    height: 3.5em;
    transform: rotate(45deg);
    background: var(--color-success);
  }
  &.active::before {
    content: '◉';
    position: absolute;
    top: 0.2em;
    left: 0.2em;
    color: var(--color-white);
    z-index: 1;
  }

  & ~ & {
    margin-top: 12px;
  }
}
.label {
  font-size: 12px;
  color: var(--color-text-3);
}
</style>